module.exports = __webpack_public_path__ + "static/media/wpp@2x.5c1432d2.png";